"use client";

import { CartIcon, TriangleRight } from "@/components/icons/assets";
import Link from "next/link";
import { useAppSelector } from "@/store/hooks";

export default function AddToCartEmptyState() {
  const cartDetail = useAppSelector((state) => state.cartDetail);
  const itemsQty = cartDetail?.cart?.itemsQty || 0;

  return (
    <main className="min-h-[500px] sm:min-h-[600px] md:min-h-[700px] lg:min-h-[738px] flex flex-col items-center justify-center px-4 sm:px-6 md:px-8 lg:px-10">
      <div className="flex items-center gap-2 mb-10">
        <Link href="/" className="font-plus-jakarta text-sm text-neutral-300 hover:text-neutral-900">
          Home
        </Link>
        <TriangleRight className="w-2 h-2.5 text-neutral-300" />
        <span className="font-plus-jakarta text-sm font-medium text-neutral-900">Add To Cart</span>
      </div>
      <div className="flex flex-col items-center">
        <div className="flex items-center gap-2">
          <CartIcon className="w-10 h-10 text-neutral-900" />
          <span className="bg-neutral-900 text-white text-xs font-medium rounded-full px-3 py-0.5">
            {itemsQty}
          </span>
        </div>
        <h1 className="font-plus-jakarta text-lg sm:text-xl md:text-2xl font-bold text-neutral-300 uppercase mt-10">
          Your cart is empty
        </h1>
      </div>
    </main>
  );
} 
